import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";
import "../css/policies.scss";

export const POLICY_DATE = "October 22, 2026";
export const POLICY_DATE_TIME = "2026-10-22";

const PolicyContact = ({ title = "Questions about this policy?", children }) => (
  <aside className="policy-demo-note">
    <h2>{title}</h2>
    <p>
      {children || (
        <>
          Contact us at{" "}
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          . Please include your order number when your question concerns a
          purchase.
        </>
      )}
    </p>
  </aside>
);

const PolicyLayout = ({ eyebrow, title, lede, nav = [], children, contact }) => (
  <main className="editorial-page policy-page">
    <div className="editorial-page__inner">
      <header className="editorial-page__hero">
        <p className="editorial-page__eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="editorial-page__lede">{lede}</p>
        <p className="policy-updated">
          Last updated{" "}
          <time dateTime={POLICY_DATE_TIME}>{POLICY_DATE}</time>
        </p>
      </header>

      {nav.length > 0 && (
        <nav className="policy-nav" aria-label={`${title} topics`}>
          {nav.map(({ href, label }) => (
            <a href={href} key={href}>
              {label}
            </a>
          ))}
        </nav>
      )}

      {children}
      {contact === false ? null : contact || <PolicyContact />}
      <p className="policy-back-link">
        <Link to="/policies">View all store policies</Link>
      </p>
    </div>
  </main>
);

export { PolicyContact };
export default PolicyLayout;
